var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"button is-primary",on:{"click":function($event){return _vm.next()}}},[_vm._v("\n        "+_vm._s(_vm.$t('labels.personalTasks'))+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }